import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Global fetch interceptor to add Authorization header for API calls
const originalFetch = window.fetch;
window.fetch = async function(url, options = {}) {
  // Only modify for our API calls
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  if (apiUrl && url.toString().includes(apiUrl)) {
    const token = localStorage.getItem('auth_token');
    if (token) {
      options.headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
      };
    }
    // Remove credentials for token-based auth (avoids CORS issues with wildcard)
    // Token in header is sufficient for authentication
    delete options.credentials;
  }
  return originalFetch(url, options);
};

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
